export function removeDiacritics(s: string) {
    return s
        .normalize('NFD')
        .replace(/[\u0100-\u017F]/g, '*') // unicode block Latin Extended-A
        .replace(/[\u0180-\u024F]/g, '*') // unicode block Latin Extended-B
        .replace(/[\u0300-\u036f]/g, ''); // unicode block combining diacritical marks
}
